/* eslint-disable */
<template>
  <div v-click-outside="hide" class="changelog">
    <div class="anchor"><!-- This is a Icon we use --></div>
  </div>
</template>

<script>
import uuid from 'uuid/v4';
import ClickOutside from 'vue-click-outside';
import { mapMutations } from 'vuex';

const HEADWAY_WIDGET_URL = '//cdn.headwayapp.co/widget.js';
export default {
  name: 'Headway',
  data() {
    return {
      id: uuid(),
      widget: undefined,
      config: {
        selector: '.changelog',
        account: 'yBMkbJ',
        callbacks: {
          onWidgetReady: widget => {
            this.widget = widget;
            // Logic that 'hides' the unseen entries in the updates list, and always applies the 'HW_badge' visible class.
            // i.e red dot.
            setTimeout(() => {
              let badge = this.widget.badgeEl.children[1].lastChild;
              badge.classList.remove('HW_softHidden');
              badge.classList.add('HW_visible');
            }, 1000);
          },
          onShowWidget: () => {
            this.$parent.$emit('close:header-items', [this.id]);
            // need so that the widget doesn't display on click, rather the activity feed slideout.
            this.hide();
            setTimeout(() => {
              let badge = this.widget.badgeEl.children[1].lastChild;
              badge.classList.remove('HW_softHidden');
              badge.classList.add('HW_visible');
            }, 50);
            this.showActivityFeed();
          }
        }
      }
    };
  },
  directives: {
    ClickOutside
  },
  methods: {
    ...mapMutations([
      'slideOut'
    ]),
    hide() {
      if (this.widget) this.widget.hide();
    },
    showActivityFeed() {
      this.slideOut({
        toggle: true,
        view: 'activityfeed'
      });
    }
  },
  mounted() {
    let headwayScript = document.createElement('script');
    headwayScript.async = true;
    headwayScript.setAttribute('src', HEADWAY_WIDGET_URL);
    document.head.appendChild(headwayScript);
    const waitForHeadway = () => {
      if (window['Headway']) {
        window.Headway.init(this.config);
      } else {
        setTimeout(() => waitForHeadway(), 100);
      }
    };
    waitForHeadway();
    this.$parent.$on('close:header-items', ([id]) => {
      if (this.id !== id) this.hide();
    });
  }
};
</script>
